import { styled } from 'linaria/react';

export const RoomParamsContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-100);
  margin-bottom: var(--space-300);

  @media (--to-tablet) {
    padding: var(--space-50) 0;
  }

  @media (--only-mobile) {
    margin-bottom: var(--space-200);
  }
`;

export const ParamsHeaderContainer = styled.div`
  flex-grow: 1;
`;

export const ParamsListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  column-gap: var(--space-300);
  row-gap: var(--space-200);
`;
